/* ============================================================
   Review badge carousel.

   Its own file because two different sections use it now — the PDP hero and
   the lander's offer box — and neither should own the other's behaviour.
   Scoped by [data-rk-revs] rather than by section, so it picks up every
   badge on the page including ones added by a section reload.
   ============================================================ */
(function () {
  function initBadge(box) {
    if (box.dataset.rkRevReady === '1') return;
    box.dataset.rkRevReady = '1';

    var slides = box.querySelectorAll('[data-rk-rev]');
    if (!slides.length) return;

    var prevB = box.querySelector('[data-rk-rev-prev]');
    var nextB = box.querySelector('[data-rk-rev-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = parseInt(box.dataset.rkDelay, 10) || 5000;
    var i = 0;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.dataset.active = String(idx === i); });
    }

    function start() {
      if (reduce || slides.length < 2 || timer) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevB) prevB.addEventListener('click', function () { stop(); show(i - 1); start(); });
    if (nextB) nextB.addEventListener('click', function () { stop(); show(i + 1); start(); });

    /* Never rotate under someone's cursor, or while they are tabbed into it. */
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', start);

    show(0);

    /* An off-screen badge should not burn a timer, and a hidden tab suspends
       the callback anyway — this keeps the two in step. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 }).observe(box);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      document.visibilityState === 'visible' ? start() : stop();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rk-revs]').forEach(initBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
